import { createElement } from 'react';
import { createSvg } from './createSvg.js';
import '@vebox/etui-system';
import '@vebox/etui-system-elements';

const CarwashGlyph = /*#__PURE__*/createElement("g", {
  id: "carwash"
}, /*#__PURE__*/createElement("path", {
  d: "M64.1,41.6c0-1.1-1.7-1.9-3.8-1.9c-1.6,0-2.9,0.5-3.5,1.2l-0.8-2.4c0,0-1.4-3.1-3.1-3.1H32.1c-1.7,0-3.1,3.1-3.1,3.1 l-1.4,2.8c-0.4-0.8-1.9-1.5-3.7-1.5c-2.1,0-3.8,0.9-3.8,1.9c0,1.1,1.7,1.9,3.8,1.9c0.5,0,1-0.1,1.5-0.1c-1.5,0.9-2.5,2.6-2.5,4.5 v2.9c0,1.1,0.4,2.2,1,3v7.1c0,1.1,0.9,1.9,1.9,1.9h2.8c1.1,0,1.9-0.9,1.9-1.9V56h23.3v4.8c0,1.1,0.9,1.9,1.9,1.9h2.8 c1.1,0,1.9-0.9,1.9-1.9v-7.1c0.6-0.9,1-1.9,1-3v-2.9c0-1.9-1-3.5-2.5-4.5c0.5,0.1,1,0.1,1.5,0.1C62.3,43.5,64.1,42.6,64.1,41.6z M30.2,48.8c-0.5,1-2,1.3-3.4,0.7c-1.3-0.7-2-2.1-1.5-3.1c0.5-1,2-1.3,3.4-0.7C30.1,46.4,30.7,47.8,30.2,48.8z M50.7,52.7 c0,0.8-0.6,1.4-1.4,1.4H33.8c-0.8,0-1.4-0.6-1.4-1.4v-2c0-0.8,0.6-1.4,1.4-1.4h15.5c0.8,0,1.4,0.6,1.4,1.4V52.7z M31,43.2l1.6-3.2 c0,0,1-2.2,2.2-2.2h14.7c1.2,0,2.2,2.2,2.2,2.2l1.1,3.2H31z M56.3,49.6c-1.4,0.5-2.9,0-3.2-1.1c-0.4-1.1,0.5-2.4,1.9-2.8 c1.4-0.5,2.9,0,3.2,1.1C58.6,47.8,57.7,49.1,56.3,49.6z"
}), /*#__PURE__*/createElement("path", {
  d: "M41.8,21.4c0,0-5.6,10.4,0,10.4C47.4,31.7,41.8,21.4,41.8,21.4z"
}), /*#__PURE__*/createElement("path", {
  d: "M33.2,19.3c0,0-5.6,10.4,0,10.4C38.8,29.6,33.2,19.3,33.2,19.3z"
}), /*#__PURE__*/createElement("path", {
  d: "M50.4,19.3c0,0-5.6,10.4,0,10.4C55.9,29.6,50.4,19.3,50.4,19.3z"
}));
const Carwash = createSvg({
  name: 'carwash',
  path: CarwashGlyph
});

export default Carwash;
export { CarwashGlyph };
